// @flow

import _ from 'lodash';

import ReduceStore from 'PMT/flux/ReduceStore';

import { SessionStore } from 'stores';

import { Events, ActionTypes, Constants } from 'constants';

import { SessionUtils, Logger } from 'PMT/utils';

import { RestaurantStore } from 'stores';

// -- entity
import ApiError from 'PMT/entities/ApiError';
import { ProDomain } from 'PMT/entities/security';

import { ProAccount } from 'PMT/entities/security';

/**
 * Handle pro accounts.
 * - `Me` is used for the for the current logged in user
 * - It also handle other pro account that the logged in user could modify (depends of
 * its permissions)
 */
class ProAccountStore extends ReduceStore {
  getInitialState() {
    // -- me account default
    let meAccount = null;
    const json = SessionUtils.getItemFromSession(Constants.SessionKey.ACCOUNT);
    if (!_.isNil(json)) {
      meAccount = new ProAccount();
      meAccount.fromJson(json);
    }

    return {
      /**
       * @type ProDomain
       */
      selectedProDomain: null,

      /**
       * @type ApiError
       */
      apiError: null,

      /**
       * The current user's account.
       * @type ProAccount
       */
      meAccount: null,

      /**
       * The created account.
       *
       * @type ProAccount
       */
      newAccount: null,

      /**
       * The updated account.
       * @type ProAccount
       */
      updateAccount: null,

      /**
       * The account to display.
       *
       * @type ProAccount
       */
      account: null,

      forgotPassword: null,
    };
  }

  isEmitingCustomEvents(): boolean {
    return true;
  }

  getStateObjectsMap() {
    return {
      apiError: new ApiError(),
      selectedProDomain: new ProDomain(),
      meAccount: new ProAccount(),
      newAccount: new ProAccount(),
      updateAccount: new ProAccount(),
      account: new ProAccount(),
    };
  }

  getApiError(): ApiError {
    return this._state.apiError;
  }

  getNewAccount(): ProAccount {
    return this._state.newAccount;
  }

  getUpdateAccount(): ProAccount {
    return this._state.updateAccount;
  }

  getAccount(): ProAccount {
    return this._state.account;
  }

  getSelectedProDomain(): ProDomain {
    return this._state.selectedProDomain;
  }

  getSelectedProDomainId(): ?string {
    if (!_.isNull(this._state.selectedProDomain)) {
      return this._state.selectedProDomain.id;
    }
    return null;
  }

  /**
   * The current logged in user account is saved in session.
   */
  getMeAccount(): ProAccount {
    if (_.isNull(this._state.meAccount)) {
      const json = SessionUtils.getItemFromSession(
        Constants.SessionKey.ACCOUNT
      );
      this._state.meAccount = new ProAccount();
      this._state.meAccount.fromJson(json);
    }

    return this._state.meAccount;
  }

  saveMeAccount(proAccount: ProAccount, state) {
    SessionUtils.saveItemToSession('ACCOUNT', proAccount);
    state.meAccount = proAccount;

    return state;
  }

  reduce(state, action, nextState) {
    switch (action.type) {
      case ActionTypes.LOGOUT:
        // -- clear user context
        Logger.clearUserContext();

        nextState.apiError = null;
        return nextState;

      case ActionTypes.PRO_FORGOT_PASSWORD_SUCCESS:
        this.emitEvent(Events.PRO_FORGOT_PASSWORD);
        nextState.meAccount.forgotPassword = true;
        return nextState;

      case ActionTypes.PRO_FORGOT_PASSWORD_FAILURE:
        this.emitEvent(Events.PRO_FORGOT_PASSWORD);
        nextState.meAccount.forgotPassword = false;
        return nextState;

      case ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
        nextState.apiError = null;
        return nextState;

      //
      // Create
      //

      case ActionTypes.PRO_ACCOUNT_CREATE_SUCCESS:
        nextState.newAccount = action.proAccount;
        nextState.apiError = null;
        return nextState;

      case ActionTypes.PRO_ACCOUNT_CREATE_FAILURE:
        nextState.apiError = action.apiError;
        return nextState;

      //
      // Retrieve
      //

      case ActionTypes.PRO_ACCOUNT_GET_SUCCESS:
        nextState.account = action.proAccount;
        nextState.apiError = null;
        return nextState;

      case ActionTypes.PRO_ACCOUNT_GET_FAILURE:
        nextState.apiError = action.apiError;
        return nextState;

      //
      // Me account
      //
      case ActionTypes.PRO_ACCOUNT_GET_ME_SUCCESS:
        this.waitFor([RestaurantStore.getDispatchToken()]);

        this.saveMeAccount(action.proAccount, nextState);
        nextState.apiError = null;

        nextState.selectedProDomain = action.proDomain;
        SessionStore.saveProDomainId(nextState.selectedProDomain.id);

        Logger.setUserContext(Logger.UserRole.RESTAURANT, action.proAccount.id);

        this.emitEvent(Events.PRO_ACCOUNT_GET_ME_SUCCESS);
        return nextState;

      case ActionTypes.PRO_ACCOUNT_GET_ME_FAILURE:
        nextState.meAccount = action.apiError;
        this.emitEvent(Events.PRO_ACCOUNT_GET_ME_FAILURE);
        return nextState;

      //
      // Update
      //

      case ActionTypes.PRO_ACCOUNT_UPDATE_SUCCESS:
        nextState.updateAccount = action.proAccount;
        nextState.apiError = null;
        return nextState;

      case ActionTypes.PRO_ACCOUNT_UPDATE_FAILURE:
        nextState.apiError = action.apiError;
        return nextState;

      //
      // Delete
      //

      case ActionTypes.PRO_ACCOUNT_DELETE_SUCCESS:
        nextState.apiError = null;
        return nextState;

      case ActionTypes.PRO_ACCOUNT_DELETE_FAILURE:
        nextState.apiError = action.apiError;
        return nextState;

      //
      // Domains
      //

      case ActionTypes.PRO_ACCOUNT_GET_DOMAINS_SUCCESS:
        nextState.meAccount = action.account; // to be sure.
        nextState.meAccount.domainsList = action.proDomainsList;
        nextState.apiError = null;
        return nextState;

      case ActionTypes.PRO_ACCOUNT_GET_DOMAINS_FAILURE:
        nextState.apiError = action.apiError;
        return nextState;

      //
      //
      //
      case ActionTypes.CHANGE_PRO_DOMAIN:
        nextState.selectedProDomain = action.proDomain;

        nextState.meAccount.role = nextState.selectedProDomain.role;
        nextState.meAccount.restaurantsGroup =
          nextState.selectedProDomain.restaurantsGroup;

        SessionStore.saveProDomainId(nextState.selectedProDomain.id);

      default:
        return nextState;
    }
  }
}

export default new ProAccountStore();



// WEBPACK FOOTER //
// ./scripts/stores/ProAccountStore.js